/* Valynest sections: scroll reveal, zone hotspots, pack picker. Safe to load more than once. */
(() => {
  if (window.__vnReady) return;
  window.__vnReady = true;

  const reveal = () => {
    const els = document.querySelectorAll('.vn [data-vn]:not(.is-in), .vn-guar__ring:not(.is-in)');
    if (!('IntersectionObserver' in window)) return els.forEach((el) => el.classList.add('is-in'));
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && (e.target.classList.add('is-in'), io.unobserve(e.target))),
      { threshold: 0.16, rootMargin: '0px 0px -6% 0px' }
    );
    els.forEach((el) => io.observe(el));
  };

  // Zones: hovering or tapping a dot (or a row) highlights the matching pair; it also cycles on its own until touched.
  const zones = () => {
    document.querySelectorAll('[data-vn-zones]').forEach((root) => {
      const dots = [...root.querySelectorAll('.vn-zone__dot')];
      const rows = [...root.querySelectorAll('.vn-zone-list li')];
      let i = 0;
      let auto = true;
      const set = (n) => {
        i = n;
        dots.forEach((d, k) => d.classList.toggle('is-on', k === n));
        rows.forEach((r, k) => r.classList.toggle('is-on', k === n));
      };
      [...dots, ...rows].forEach((el) => {
        const n = el.matches('li') ? rows.indexOf(el) : dots.indexOf(el);
        ['click', 'mouseenter', 'focusin'].forEach((ev) => el.addEventListener(ev, () => ((auto = false), set(n))));
      });
      set(0);
      setInterval(() => auto && set((i + 1) % rows.length), 3200);
    });
  };

  // Pack picker: the chosen pack sets the product form quantity (the 2-pillow discount applies automatically in cart).
  const packs = () => {
    document.addEventListener('change', (ev) => {
      const input = ev.target.closest('.vn-pack input[type=radio]');
      if (!input) return;
      const scope = input.closest('product-form-component, form, .product-details, body') || document;
      const qty = scope.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
      document.querySelectorAll('[data-vn-price]').forEach((el) => (el.hidden = el.dataset.vnPrice !== input.value));
      if (!qty) return;
      qty.value = input.value;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  // Selection card: picking the other pack swaps which one sits in the card, the price shown and the form quantity.
  const pickPack = () => {
    document.addEventListener('click', (ev) => {
      const btn = ev.target.closest('[data-vn-pack-pick]');
      if (!btn) return;
      const n = btn.dataset.vnPackPick;
      document.querySelectorAll('[data-vn-pack-show]').forEach((el) => (el.hidden = el.dataset.vnPackShow !== n));
      document.querySelectorAll('[data-vn-min]').forEach((el) => (el.hidden = Number(n) < Number(el.dataset.vnMin)));
      document.querySelectorAll('[data-vn-pack-pick]').forEach((el) => (el.hidden = el.dataset.vnPackPick === n));
      document.querySelectorAll('[data-vn-price]').forEach((el) => (el.hidden = el.dataset.vnPrice !== n));
      document.querySelectorAll('input[name="quantity"]').forEach((qty) => {
        qty.value = n;
        qty.dispatchEvent(new Event('input', { bubbles: true }));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  // Reviews row: drifts on its own, loops through the duplicated list, and yields to the visitor for a few seconds after any interaction.
  const revs = () => {
    document.querySelectorAll('[data-vn-revs-row]').forEach((row) => {
      let hold = 0;
      let pos = 0;
      const pause = (ms) => (hold = performance.now() + ms);
      ['pointerdown', 'touchstart', 'wheel', 'mouseenter'].forEach((ev) => row.addEventListener(ev, () => pause(2500), { passive: true }));
      ['touchend', 'pointerup'].forEach((ev) => row.addEventListener(ev, () => pause(1500), { passive: true }));
      row.addEventListener('mouseleave', () => pause(600));
      row.closest('.vn-revs').addEventListener('click', (ev) => {
        const btn = ev.target.closest('[data-vn-revs]');
        if (!btn) return;
        pause(5000);
        row.scrollBy({ left: Number(btn.dataset.vnRevs) * Math.min(560, row.clientWidth * 0.8), behavior: 'smooth' });
      });
      const tick = (now) => {
        const half = row.scrollWidth / 2;
        if (now > hold && half > row.clientWidth) row.scrollLeft = pos = (pos >= half ? pos - half : pos) + 0.6;
        else pos = row.scrollLeft;
        if (row.scrollLeft >= half) row.scrollLeft = pos = row.scrollLeft - half;
        else if (row.scrollLeft <= 0 && now < hold) row.scrollLeft += half;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  };

  // Multi-pillow packs: pillows in the first colour go through the form as its quantity; other colours are added first, then the form is submitted.
  const pack2 = () => {
    document.addEventListener(
      'click',
      (ev) => {
        const btn = ev.target.closest('.add-to-cart-button');
        if (!btn || btn.__vnGo) return;
        const form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
        const first = form && form.querySelector('input[name="id"]');
        if (!first) return;
        const extras = [...document.querySelectorAll('.vn-color2:not([hidden]) input:checked')].map((el) => el.value);
        const others = extras.filter((id) => id !== first.value);
        document.querySelectorAll('input[name="quantity"]').forEach((qty) => (qty.value = 1 + extras.length - others.length));
        if (!others.length) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        const count = {};
        others.forEach((id) => (count[id] = (count[id] || 0) + 1));
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: Object.keys(count).map((id) => ({ id: Number(id), quantity: count[id] })) }),
        }).finally(() => {
          btn.__vnGo = true;
          btn.click();
          btn.__vnGo = false;
        });
      },
      true
    );
  };

  // Pack colours: name the chosen colour next to each picker ("1st pillow color: Gray") so a 2- or 3-pack reads as one colour choice per pillow.
  const colourNames = () => {
    const paint = () => {
      document.querySelectorAll('.vn-color2').forEach((row) => {
        const on = row.querySelector('input:checked');
        const out = row.querySelector('[data-vn-cname]');
        if (on && out) out.textContent = on.getAttribute('aria-label');
      });
      const shown = document.querySelector('[data-vn-price]:not([hidden])');
      const pack = shown ? Number(shown.dataset.vnPrice) : 1;
      document.querySelectorAll('.product-details variant-picker legend').forEach((legend) => {
        const on = legend.closest('fieldset').querySelector('input:checked');
        const name = legend.dataset.vnName || (legend.dataset.vnName = legend.textContent.split(':')[0].trim());
        const first = pack > 1 && /size/i.test(name);
        const text = (first ? '1st pair size: ' : name + ': ') + (on ? on.value : '');
        if (legend.textContent.trim() !== text) legend.textContent = text;
      });
    };
    ['change', 'click'].forEach((ev) => document.addEventListener(ev, () => [0, 250, 900].forEach((ms) => setTimeout(paint, ms))));
    paint();
  };

  // Feature videos: no download until the card is near the screen (keeps the page light on phones).
  const lazyVideos = () => {
    const vids = [...document.querySelectorAll('video source[data-src]')].map((s) => s.parentElement);
    const load = (v) => {
      v.querySelectorAll('source[data-src]').forEach((s) => (s.src = s.dataset.src, s.removeAttribute('data-src')));
      v.load();
      v.play && v.play().catch(() => {});
    };
    if (!('IntersectionObserver' in window)) return vids.forEach(load);
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && (load(e.target), io.unobserve(e.target))),
      { rootMargin: '300px 0px' }
    );
    vids.forEach((v) => io.observe(v));
  };

  const init = () => (reveal(), lazyVideos(), zones(), packs(), pickPack(), revs(), pack2(), colourNames());
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', reveal);
})();
